import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Order } from '../../models/order';
import { OrderService } from '../../services/order.service';

@Component({
  templateUrl: './next-order.component.html',
  styleUrls: ['./next-order.component.scss'],
})
export class NextOrderComponent implements OnInit, OnDestroy {
  private readonly COUNTDOWN_DURATION: number = 8;

  @Input({ required: true }) nextOrder!: Order;
  timerCount: number = 0;
  timerRefrence: any;

  constructor(
    private modalController: ModalController,
    private orderService: OrderService
  ) {

  }

  ngOnInit(): void {
    this.timerRefrence = setInterval(() => {
      if (this.timerCount >= this.COUNTDOWN_DURATION) {
        this.startNextOrder();
      }
      this.timerCount += 0.2;
    }, 200);
  }

  ngOnDestroy(): void {
    clearInterval(this.timerRefrence);
  }

  get progressBarValue(): number {
    return this.timerCount / 8;
  }

  async closeModal(): Promise<void> {
    clearInterval(this.timerRefrence);
    const topModal = await this.modalController.getTop();
    if (topModal) {
      await this.modalController.dismiss();
    }
  }

  startNextOrder(): void {
    this.orderService.startDelivery(this.nextOrder.id)
      .subscribe(() => {
        this.orderService.refreshOrders().subscribe();
        this.closeModal();
      });
  }
}
